import {
  getLocaleFromLocalizedUrl,
  getLocaleFromBrowser,
  getLocaleFromLocalStorage,
  getLocaleFromCookie,
  setLocaleToCookie,
  getIsLocale,
} from '../../lib'
import isLocaleSupported from '../../lib/getIsLocaleSupported'
import supportedLocales, { defaultLocale } from '../../supportedLocales'
import getIsURLLocalizableRoute from '../getIsURLLocalizableRoute'

/**
 * By looking at all the sources for locale, including the
 * localizable URL routes, returns a locale we support
 * or a fallback.
 */
const getCurrentLocaleFromSources = (): string => {
  try {
    const location = window && window.location
    const pathname = location && location.pathname

    const extractedLocales = getIsURLLocalizableRoute(window.location.pathname)
      ? [getLocaleFromLocalizedUrl(pathname)]
      : [
          getLocaleFromBrowser(),
          getLocaleFromLocalStorage(),
          getLocaleFromCookie(),
        ]

    const derivedLocale = extractedLocales.reduce(
      (prevLocale, currLocale) =>
        isLocaleSupported(currLocale, supportedLocales)
          ? currLocale
          : prevLocale,
      defaultLocale
    )

    if (getIsLocale(derivedLocale)) {
      /**
       * Update Cookie based on URL derived locale
       */
      if (getIsURLLocalizableRoute(window.location.pathname)) {
        setLocaleToCookie(derivedLocale)
      }
    } else {
      console.warn(
        `Derived locale ${derivedLocale}, but it was not a valid locale.`
      )
      return defaultLocale
    }
    return derivedLocale
  } catch (e) {
    return defaultLocale
  }
}

export default getCurrentLocaleFromSources
